import {$http} from '@utils'
import queryString from 'query-string'
import api from '@utils/api'
import Vue from 'vue'
import {message} from 'ant-design-vue'
Vue.use(message)
const formatData = function(payload){
    if(!payload.data){
        payload = {
            ...payload,
            data:[],
            count:0
        }
    } else if(payload.data.length>0&&!payload.data[0]) {
        payload = {
            ...payload,
            data:[],
            count:0
        }
    }
    return payload
}
export default {
    namespaced: true,
    state:{
        resList:[],
        queryRoleData:{},
    },
    mutations:{
        getResList(state,payload){
            payload = formatData(payload)
            // console.table(payload.data)
            state.resList = payload.data.map(item=>({
              resId:item.appCode,
              resName:item.appName,
              subResList:item.resList
            }))
        },
        toModifyRole(state,payload){
            // console.table(payload.data)
            state.queryRoleData = payload.data?payload.data.roleDetail:{}
        },
    },
    actions:{
        async addRole ({commit},{param,callback}) {
            const res = await $http.post(`${api.mainHost}/portal-api/role/addRole.do`,queryString.stringify({param}),{
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (res.code * 1 === 1) {
                callback&&callback()
            } else {
                message.error(res.msg)
            }
        },
        async modifyRole ({commit},{param,callback}) {
            const res = await $http.post(`${api.mainHost}/portal-api/role/modifyRole.do`,queryString.stringify({param}),{
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (res.code * 1 === 1) {
                callback&&callback()
            } else {
                message.error(res.msg)
            }
        },
        async getResList ({commit},{params}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/role/getResList.do?${queryString.stringify(params)}`);
            if (res.code * 1 === 1) {
                commit('getResList', res)
            } else {
                message.error(res.msg)
            }
        },
        async toModifyRole ({commit},{params}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/role/toModifyRole.do?${queryString.stringify(params)}`);
            if (res.code * 1 === 1) {
                commit('toModifyRole', res)
            } else {
                message.error(res.msg)
            }
        },
    }
}